// import { useEffect } from "react";
import AppRoutes from "./routes/AppRoutes";
// import { detectLanguage } from "./utils/detectLanguage";

export default function App() {
//   useEffect(() => {
//     let r = detectLanguage();
//     console.log("Valeur de r", r)
//   }, []);

  return <AppRoutes />;
}
